import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const progressCircleDefaultVariants = {
  "size": "md",
  "color": "green",
  "isZero": false
}
const progressCircleCompoundVariants = []

const progressCircleSlotNames = [
  [
    "root",
    "progressCircle__root"
  ],
  [
    "svg",
    "progressCircle__svg"
  ],
  [
    "track",
    "progressCircle__track"
  ],
  [
    "border",
    "progressCircle__border"
  ],
  [
    "indicator",
    "progressCircle__indicator"
  ],
  [
    "content",
    "progressCircle__content"
  ],
  [
    "icon",
    "progressCircle__icon"
  ]
]
const progressCircleSlotFns = /* @__PURE__ */ progressCircleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, progressCircleDefaultVariants, getSlotCompoundVariant(progressCircleCompoundVariants, slotName))])

const progressCircleFn = memo((props = {}) => {
  return Object.fromEntries(progressCircleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const progressCircleVariantKeys = [
  "size",
  "color",
  "isZero"
]
const getVariantProps = (variants) => ({ ...progressCircleDefaultVariants, ...compact(variants) })

export const progressCircle = /* @__PURE__ */ Object.assign(progressCircleFn, {
  __recipe__: false,
  __name__: 'progressCircle',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: progressCircleVariantKeys,
  variantMap: {
  "size": [
    "md",
    "sm"
  ],
  "color": [
    "green",
    "orange"
  ],
  "isZero": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, progressCircleVariantKeys)
  },
  getVariantProps
})